function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment, useMemo } from 'react';
import { classnames, guid } from '@bydesign-ui/utils';
import { useRefCallback, useAutoControlled } from '@bydesign-ui/hooks';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { ColumnType } from '../../models/table';
import { convertColumn } from '../../units/table/util/column';
import { Right } from '../../common/icons';
import { Checkbox } from '../checkbox';
import { PureTable } from '../pure-table';
import { Empty } from '../empty';
import { Radio } from '../radio';
import { Pager } from '../pager/Pager';
var Head = PureTable.Head,
    Body = PureTable.Body,
    RowGroup = PureTable.RowGroup,
    ScrollerBar = PureTable.ScrollerBar;
var rowSelectionId = guid();
var rowExpandId = guid();

function useRowSelection(datasource, rowKey, selection) {
  var _usePrefixCls;

  var _ref = selection || {},
      _ref$selectedRowKeys = _ref.selectedRowKeys,
      selectedRowKeys = _ref$selectedRowKeys === void 0 ? [] : _ref$selectedRowKeys,
      onChange = _ref.onChange,
      columnTitle = _ref.columnTitle,
      _ref$columnWidth = _ref.columnWidth,
      columnWidth = _ref$columnWidth === void 0 ? 60 : _ref$columnWidth,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      _ref$valign = _ref.valign,
      valign = _ref$valign === void 0 ? 'middle' : _ref$valign,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? false : _ref$fixed,
      getCheckboxProps = _ref.getCheckboxProps;

  var onChangeCallback = useRefCallback(onChange);
  var selectionCls = usePrefixCls('table-row-selection', (_usePrefixCls = {}, _defineProperty(_usePrefixCls, align, true), _defineProperty(_usePrefixCls, valign, true), _usePrefixCls));
  var datasourceMap = useMemo(function () {
    return selectedRowKeys.reduce(function (map, key) {
      return map.set(key, true);
    }, new Map());
  }, [selectedRowKeys]);

  if (selection == null) {
    return null;
  }

  return {
    type: ColumnType.LEAF,
    fixed: fixed ? 'left' : false,
    key: rowSelectionId,
    width: columnWidth,
    widthFixed: true,
    className: selectionCls,
    renderHead: columnTitle || type === 'radio' ? function () {
      return columnTitle;
    } : function () {
      var selectedRowKeysLength = selectedRowKeys.length;
      var isRenderMatchAllSelected = Boolean(selectedRowKeysLength && datasource.length <= selectedRowKeysLength);
      var isRenderMatchAtLeastOneSelected = false;
      var currentPageAvailableKeys = datasource.filter(function (row) {
        var _a;

        return !((_a = getCheckboxProps === null || getCheckboxProps === void 0 ? void 0 : getCheckboxProps(row)) === null || _a === void 0 ? void 0 : _a.disabled);
      }).map(function (row) {
        return row[rowKey];
      });

      if (selectedRowKeysLength) {
        for (var i = 0; i < datasource.length; i++) {
          var key = datasource[i][rowKey];

          if (datasourceMap.get(key)) {
            if (!isRenderMatchAtLeastOneSelected) {
              isRenderMatchAtLeastOneSelected = true;
            }
          } else {
            if (isRenderMatchAllSelected) {
              isRenderMatchAllSelected = false;
            }
          }
        }

        if (isRenderMatchAllSelected && isRenderMatchAtLeastOneSelected) {
          isRenderMatchAtLeastOneSelected = false;
        }
      }

      var onSelect = function onSelect(checked) {
        if (checked) {
          if (currentPageAvailableKeys.every(function (k) {
            return selectedRowKeys.includes(k);
          })) {
            onChangeCallback(selectedRowKeys.filter(function (k) {
              return !currentPageAvailableKeys.includes(k);
            }));
          } else {
            onChangeCallback(_toConsumableArray(new Set([].concat(_toConsumableArray(selectedRowKeys), _toConsumableArray(currentPageAvailableKeys)))));
          }
        } else {
          onChangeCallback(selectedRowKeys.filter(function (k) {
            return !currentPageAvailableKeys.includes(k);
          }));
        }
      };

      return React.createElement(Checkbox, {
        checked: isRenderMatchAllSelected,
        indeterminate: isRenderMatchAtLeastOneSelected,
        onValueChange: onSelect,
        disabled: currentPageAvailableKeys.length === 0
      });
    },
    renderData: type === 'radio' ? function (row) {
      var key = row[rowKey];

      var onSelect = function onSelect(checked) {
        if (!checked) {
          return;
        }

        onChangeCallback([key]);
      };

      return React.createElement(Radio, Object.assign({}, getCheckboxProps ? getCheckboxProps(row) : {}, {
        checked: selectedRowKeys.indexOf(key) >= 0,
        onValueChange: onSelect
      }));
    } : function (row) {
      var key = row[rowKey];

      var onSelect = function onSelect(checked) {
        var nv = selectedRowKeys.slice();
        var index = selectedRowKeys.indexOf(key);

        if (checked && index < 0) {
          nv.push(key);
        } else if (!checked && index >= 0) {
          nv.splice(index, 1);
        }

        onChangeCallback(nv);
      };

      return React.createElement(Checkbox, Object.assign({}, getCheckboxProps ? getCheckboxProps(row) : {}, {
        checked: selectedRowKeys.indexOf(key) >= 0,
        onValueChange: onSelect
      }));
    }
  };
}

function useExpandTrigger(datasource, rowExpandTrigger, renderExpand) {
  var expandedRows = rowExpandTrigger.expandedRows,
      onExpandedRowsChange = rowExpandTrigger.onExpandedRowsChange,
      _rowExpandTrigger$sho = rowExpandTrigger.show,
      show = _rowExpandTrigger$sho === void 0 ? 'auto' : _rowExpandTrigger$sho,
      _rowExpandTrigger$wid = rowExpandTrigger.width,
      width = _rowExpandTrigger$wid === void 0 ? 48 : _rowExpandTrigger$wid,
      _rowExpandTrigger$fix = rowExpandTrigger.fixed,
      fixed = _rowExpandTrigger$fix === void 0 ? true : _rowExpandTrigger$fix,
      _rowExpandTrigger$ali = rowExpandTrigger.align,
      align = _rowExpandTrigger$ali === void 0 ? 'center' : _rowExpandTrigger$ali,
      renderHeader = rowExpandTrigger.renderHeader,
      renderTrigger = rowExpandTrigger.renderTrigger;
  var rowExpandCls = usePrefixCls('table-expand-trigger', _defineProperty({}, align, true));
  var rowExpandIconCls = usePrefixCls('table-expand-trigger-icon');
  var rowExpandIconExpandedCls = usePrefixCls('table-expand-trigger-icon', {
    expanded: true
  });
  var renderHead = useRefCallback(renderHeader ? function () {
    return renderHeader(expandedRows, onExpandedRowsChange);
  } : function () {
    return null;
  });
  var renderData = useRefCallback(renderTrigger !== null && renderTrigger !== void 0 ? renderTrigger : !!renderExpand && function (row, _ref2, onExpand) {
    var isLeaf = _ref2.isLeaf,
        level = _ref2.level,
        expanded = _ref2.expanded;
    return React.createElement(Right, {
      className: expanded && rowExpandIconExpandedCls || rowExpandIconCls,
      onClick: function onClick() {
        return onExpand(!expanded);
      }
    });
  } || function (row, _ref3, onExpand) {
    var isLeaf = _ref3.isLeaf,
        level = _ref3.level,
        expanded = _ref3.expanded;
    return !isLeaf && React.createElement(Right, {
      className: expanded && rowExpandIconExpandedCls || rowExpandIconCls,
      onClick: function onClick() {
        return onExpand(!expanded);
      }
    });
  });
  var showColumn = show === 'auto' ? !!renderExpand || datasource && datasource.some(function (row) {
    return row.children && Array.isArray(row.children) && row.children.length > 0;
  }) : show;
  var column = {
    type: ColumnType.LEAF,
    fixed: fixed && 'left',
    key: rowExpandId,
    width: width,
    widthFixed: true,
    className: rowExpandCls,
    renderHead: renderHead,
    renderData: renderData
  };
  return [showColumn, column];
}

function getNewSorter(sorter, key, order, multipleSorter) {
  if (!multipleSorter) {
    return order === 'reset' ? [] : [{
      column: key,
      order: order
    }];
  }

  var index = sorter.findIndex(function (item) {
    return item.column === key;
  });

  if (index < 0) {
    if (order === 'reset') {
      return sorter;
    }

    return multipleSorter === 'post-selection-first' ? [{
      column: key,
      order: order
    }].concat(sorter) : sorter.concat({
      column: key,
      order: order
    });
  }

  var result = sorter.slice();

  if (order === 'reset') {
    result.splice(index, 1);
  } else {
    result.splice(index, 1, {
      column: key,
      order: order
    });
  }

  return result;
}

export function Table(props) {
  var datasource = props.datasource,
      _props$fixedHeader = props.fixedHeader,
      fixedHeader = _props$fixedHeader === void 0 ? false : _props$fixedHeader,
      _props$noHeader = props.noHeader,
      noHeader = _props$noHeader === void 0 ? false : _props$noHeader,
      scroll = props.scroll,
      footer = props.footer,
      footerClassName = props.footerClassName,
      footerStyle = props.footerStyle,
      rowKey = props.rowKey,
      columns = props.columns,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      rowClassName = props.rowClassName,
      onRow = props.onRow,
      onHead = props.onHead,
      rowExpandTrigger = props.rowExpandTrigger,
      renderExpand = props.renderExpand,
      renderExpandHeight = props.renderExpandHeight,
      expandedRowKeys = props.expandedRowKeys,
      onExpandedRowChange = props.onExpandedRowChange,
      rowSelection = props.rowSelection,
      _props$sorter = props.sorter,
      sorter = _props$sorter === void 0 ? [] : _props$sorter,
      _props$filters = props.filters,
      filters = _props$filters === void 0 ? {} : _props$filters,
      _props$multipleSorter = props.multipleSorter,
      multipleSorter = _props$multipleSorter === void 0 ? false : _props$multipleSorter,
      _props$pager = props.pager,
      pager = _props$pager === void 0 ? false : _props$pager,
      onChange = props.onChange,
      renderEmpty = props.renderEmpty,
      emptyText = props.emptyText,
      extra = _objectWithoutProperties(props, ["datasource", "fixedHeader", "noHeader", "scroll", "footer", "footerClassName", "footerStyle", "rowKey", "columns", "bodyClassName", "bodyStyle", "rowClassName", "onRow", "onHead", "rowExpandTrigger", "renderExpand", "renderExpandHeight", "expandedRowKeys", "onExpandedRowChange", "rowSelection", "sorter", "filters", "multipleSorter", "pager", "onChange", "renderEmpty", "emptyText"]);

  var defaultEmptyText = useLocale('table.emptyText');
  var renderEmptyCallback = useRefCallback(renderEmpty);
  var onChangeCallback = useRefCallback(onChange);

  var _ref4 = pager || {},
      _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? 'bottom' : _ref4$position,
      _ref4$pageSize = _ref4.pageSize,
      pageSize = _ref4$pageSize === void 0 ? 10 : _ref4$pageSize,
      _ref4$page = _ref4.page,
      page = _ref4$page === void 0 ? 1 : _ref4$page,
      _ref4$align = _ref4.align,
      align = _ref4$align === void 0 ? 'right' : _ref4$align;

  var emptyCls = usePrefixCls('table-cell', {
    first: true,
    last: true,
    bottom: props.outerBordered
  });

  var onPageChange = function onPageChange(page) {
    onChangeCallback({
      page: page,
      sorter: sorter,
      pageSize: pageSize,
      filters: filters
    });
  };

  var onPageSizeChange = function onPageSizeChange(page, pageSize) {
    onChangeCallback({
      page: page,
      sorter: sorter,
      pageSize: pageSize,
      filters: filters
    });
  };

  var onSorterChange = function onSorterChange(key, order) {
    onChangeCallback({
      page: page,
      sorter: getNewSorter(sorter, key, order, multipleSorter),
      pageSize: pageSize,
      filters: filters
    });
  };

  var onFilterChange = function onFilterChange(key, nv) {
    onChangeCallback({
      page: 1,
      sorter: sorter,
      pageSize: pageSize,
      filters: _objectSpread(_objectSpread({}, filters), {}, _defineProperty({}, key, nv)),
      extra: {
        filterTriggerKey: key
      }
    });
  };

  var renderColumns = columns.map(function (item) {
    return convertColumn(item, sorter, filters, onSorterChange, onFilterChange);
  });
  var rowSelectionColumn = useRowSelection(datasource, rowKey, rowSelection);

  if (rowSelectionColumn != null) {
    renderColumns.unshift(rowSelectionColumn);
  }

  var _useAutoControlled = useAutoControlled({
    defaultValue: [],
    value: (rowExpandTrigger === null || rowExpandTrigger === void 0 ? void 0 : rowExpandTrigger.expandedRows) || expandedRowKeys,
    onChange: (rowExpandTrigger === null || rowExpandTrigger === void 0 ? void 0 : rowExpandTrigger.onExpandedRowsChange) || onExpandedRowChange
  }),
      _useAutoControlled2 = _slicedToArray(_useAutoControlled, 2),
      expandedRows = _useAutoControlled2[0],
      onExpandedRowsChange = _useAutoControlled2[1];

  var _useExpandTrigger = useExpandTrigger(datasource, _objectSpread(_objectSpread({}, rowExpandTrigger), {}, {
    expandedRows: expandedRows,
    onExpandedRowsChange: onExpandedRowsChange
  }), renderExpand),
      _useExpandTrigger2 = _slicedToArray(_useExpandTrigger, 2),
      showExpandTriggerColumn = _useExpandTrigger2[0],
      expandTriggerColumn = _useExpandTrigger2[1];

  if (showExpandTriggerColumn) {
    renderColumns.unshift(expandTriggerColumn);
  }

  var topPagerCls = usePrefixCls('table-pager', _defineProperty({
    top: true
  }, align, true));
  var bottomPagerCls = usePrefixCls('table-pager', _defineProperty({
    bottom: true
  }, align, true));
  var footerCls = classnames(usePrefixCls('table-footer', {
    bordered: extra.bordered,
    'outer-bordered': extra.outerBordered
  }), footerClassName);

  var getFooter = function getFooter() {
    return React.createElement(Fragment, null, typeof footer === 'function' && React.createElement("div", {
      className: footerCls,
      style: footerStyle
    }, footer(datasource)));
  };

  var content = function content() {
    return React.createElement(Fragment, null, React.createElement(Body, {
      borderTop: noHeader,
      className: classnames(bodyClassName, footer ? 'has-footer' : ''),
      style: _objectSpread(_objectSpread({}, bodyStyle), {}, {
        maxHeight: fixedHeader ? scroll === null || scroll === void 0 ? void 0 : scroll.y : undefined,
        overflowY: fixedHeader ? 'auto' : undefined
      })
    }, React.createElement(RowGroup, {
      rowClassName: rowClassName,
      expandedRowKeys: expandedRows,
      onExpandedRowChange: onExpandedRowsChange,
      datasource: datasource,
      onRow: onRow,
      renderExpand: renderExpand,
      renderExpandHeight: renderExpandHeight
    })), React.createElement(ScrollerBar, {
      fixed: true
    }), getFooter(), pager && position !== 'top' && React.createElement("div", {
      className: bottomPagerCls
    }, React.createElement(Pager, Object.assign({}, pager, {
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }))));
  };

  var empty = function empty() {
    var emptyInner = React.createElement(Empty, {
      content: emptyText == null ? defaultEmptyText : emptyText
    });
    var emptyContent = renderEmptyCallback();

    if (emptyContent) {
      emptyInner = React.createElement(Empty, null, emptyContent);
    }

    return React.createElement("div", {
      className: emptyCls
    }, emptyInner);
  };

  return React.createElement(PureTable, Object.assign({
    columns: renderColumns,
    rowKey: rowKey
  }, extra, {
    fixedScrollBar: true
  }), pager && position !== 'bottom' && React.createElement("div", {
    className: topPagerCls
  }, React.createElement(Pager, Object.assign({}, pager, {
    onPageChange: onPageChange,
    onPageSizeChange: onPageSizeChange
  }))), !noHeader && React.createElement(Head, Object.assign({}, onHead && onHead() || {}, {
    fixed: fixedHeader
  })), (datasource === null || datasource === void 0 ? void 0 : datasource.length) ? content() : empty());
}